// extracted by mini-css-extract-plugin
export var active = "_uz-1";
export var circle = "_uz-0";
export var completed = "_uz-2";
export var connector = "_uz-4";
export var connectorCompleted = "_uz-7";
export var connectorSpacer = "_uz-5";
export var iconStrokeOverride = "_uz-8";
export var labelContainer = "_uz-6";
export var pending = "_uz-3";